import { Pipe, PipeTransform } from '@angular/core';
import { EventService } from '../services/event.service';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {

  constructor(private eventService: EventService) {}

  transform(date: any, args?: any): any {
    if (date === null) {
      return '-'
    } else {
      let dateEx = new Date(date);
      let day = dateEx.getDate();
      let monthEx = dateEx.getMonth() + 1;
      let year = dateEx.getFullYear();
      let month = this.eventService.getMonthName(monthEx, true);
      // if (dayIsTrue) {
        //   return month + ' ' + year + 'г.';
        // }
        return day + ' ' + month + ' ' + year + 'г.';
      }
    }
}
